
<!-- 
  Single article page
-->

<template lang="html">
  <div>
    <section class="hero is-medium article-header" v-bind:style="{ backgroundColor: thisproject.bgcolor }">
      <img class="article-header-img-desktop" :src="'../../static/img/site/'+thisproject.poster+'.jpg'" />
    <!--   <img class="article-header-img-mobile" :src="'../../static/img/site/'+thisproject.poster+'_mobile-min.jpg'" />
 -->
    </section>

    <section class="content">  
      <div class="article-inner">

        <article-username
          :project="thisproject"
        >
        </article-username>

        <article-view
          :project="thisproject"
        >
        </article-view>
      </div>
    </section>
  </div>
</template>



<style type="text/css">
 
.article-header {
  position: relative;
  margin-top: 73px;
}
.article-header img {
    max-width: 100%;
    width: 100%;
}
.article-inner {
  width:520px;
  margin: 0 auto;
}
.article-header-img-desktop {
  display: block;
}
/*.article-header-img-mobile {
  display: none;
}
*/
@media only screen and (max-width: 620px) {
  .article-header {
    margin-top: 40px;
  }
 /* .article-header-img-desktop {
    display: none;
  }
  .article-header-img-mobile {
    display: block;
  }*/
}


</style>

<script>
import postData from '../../content.json'
import ArticleUsername from '../components/ArticleUsername.vue'
import ArticleView from '../components/ArticleView.vue'

export default {
  name: 'projects',
  props: ['project'],
  data: function () {
    return {
      projects: [],
      thisproject: {}
    }
  },
  methods: {
    loadProjects: function () {
      this.projects = postData
    },
    fetchData () {
      this.url = this.$route.params.id
    },
    getProject: function () {
      for (var i = 0; this.projects.length > i; i++) {
        if (this.projects[i].dir === this.url) return this.projects[i]
      }
    }
  },
  mounted: function () {
    this.loadProjects()
    this.fetchData()
    // if data is not passed from home page then load content
    if (this.project === undefined) {
      this.thisproject = this.getProject()
    } else {
      this.thisproject = this.project
    }

    setTimeout(function () { window.scrollTo(0, 0) }, 600)
  },
  components: { ArticleView, ArticleUsername }
}
</script>


// WEBPACK FOOTER //
// SingleArticle.vue?5f28dc12